module.exports = __webpack_public_path__ + "img/salud-mental.c7877cef.png";